// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".stackSheet[data-v-eb7e1a5c]{position:relative}.stackSpark[data-v-eb7e1a5c]{position:absolute;top:0;left:0}", ""]);
// Exports
module.exports = exports;
